/** Erlaubte Dateitypen für Dokument-Uploads (deckt die vom Backend akzeptierten MIME-Typen ab). */
export const ALLOWED_DOCUMENT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.txt';

export interface DocumentFileMeta {
  icon: string;
  colorClass: string;
}

function getExtension(nameOrPath: string | null | undefined): string {
  if (!nameOrPath) return '';
  const name = nameOrPath.split('/').pop() ?? nameOrPath;
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
}

/** Icon + Farbklasse passend zum Dateityp (PrimeIcons 7). */
export function getDocumentFileMeta(nameOrPath: string | null | undefined): DocumentFileMeta {
  switch (getExtension(nameOrPath)) {
    case 'pdf':
      return { icon: 'pi pi-file-pdf', colorClass: 'text-red-600' };
    case 'doc':
    case 'docx':
      return { icon: 'pi pi-file-word', colorClass: 'text-blue-600' };
    case 'xls':
    case 'xlsx':
      return { icon: 'pi pi-file-excel', colorClass: 'text-green-600' };
    case 'txt':
      return { icon: 'pi pi-file', colorClass: 'text-gray-600' };
    default:
      return { icon: 'pi pi-file', colorClass: 'text-gray-500' };
  }
}

/** Nur PDF und Text lassen sich zuverlässig inline im <iframe> anzeigen. */
export function isPreviewableDocument(nameOrPath: string | null | undefined): boolean {
  const ext = getExtension(nameOrPath);
  return ext === 'pdf' || ext === 'txt';
}
